module.exports = "/images/logo.png?a88f47c2365e786dfd78c9c385aa235d";